/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, type ReactNode, type Ref } from 'react';

import { jsx } from '@compiled/react';

import type { StrictXCSSProp } from '@atlaskit/css';

type ListItemProps = {
	children: ReactNode;
	testId?: string;
	xcss?: StrictXCSSProp<'display' | 'scrollMarginInline', never>;
};

function _ListItem({ children, testId, xcss }: ListItemProps, ref: Ref<HTMLDivElement>) {
	return (
		<div role="listitem" ref={ref} className={xcss} data-testid={testId}>
			{children}
		</div>
	);
}

/**
 * __List item__
 *
 * An element with the role of `listitem`.
 */
export const ListItem = forwardRef<HTMLDivElement, ListItemProps>(_ListItem);
